import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_manageKPI = _resolveComponent("manageKPI")!
  const _component_viewCompliance = _resolveComponent("viewCompliance")!
  const _component_editCompliance = _resolveComponent("editCompliance")!
  const _component_complianceControls = _resolveComponent("complianceControls")!
  const _component_startCompliance = _resolveComponent("startCompliance")!
  const _component_taskEdit = _resolveComponent("taskEdit")!
  const _component_crTaskEdit = _resolveComponent("crTaskEdit")!
  const _component_findings = _resolveComponent("findings")!
  const _component_actionTaskEdit = _resolveComponent("actionTaskEdit")!
  const _component_editControl = _resolveComponent("editControl")!
  const _component_systemControlMapping = _resolveComponent("systemControlMapping")!
  const _component_projectControlMapping = _resolveComponent("projectControlMapping")!
  const _component_manageRootControlMap = _resolveComponent("manageRootControlMap")!
  const _component_objectiveControlsMap = _resolveComponent("objectiveControlsMap")!
  const _component_detailsModal = _resolveComponent("detailsModal")!

  return (_openBlock(), _createBlock(_component_detailsModal, {
    modelValue: _ctx.showDetailsModal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showDetailsModal) = $event)),
    title: _ctx.detailsHeader,
    showBack: _ctx.detailsStack.length > 1,
    onClose: _ctx.closeDetailsModal,
    onBack: _ctx.backDetailsModal
  }, {
    default: _withCtx(() => [
      (_ctx.detailsView === 'manageKPI')
        ? (_openBlock(), _createBlock(_component_manageKPI, {
            key: 'manageKPI-' + _ctx.detailsParams.controlId,
            controlId: _ctx.detailsParams.controlId,
            type: _ctx.detailsParams.type,
            modalMode: true,
            onHeaderInfo: _ctx.setDetailsHeader,
            onOpenNested: _ctx.openNested
          }, null, 8, ["controlId", "type", "onHeaderInfo", "onOpenNested"]))
        : (_ctx.detailsView === 'viewCompliance')
          ? (_openBlock(), _createBlock(_component_viewCompliance, {
              key: 'viewCompliance-' + _ctx.detailsParams.complianceId,
              complianceId: _ctx.detailsParams.complianceId,
              modalMode: true,
              onHeaderInfo: _ctx.setDetailsHeader,
              onOpenNested: _ctx.openNested
            }, null, 8, ["complianceId", "onHeaderInfo", "onOpenNested"]))
          : (_ctx.detailsView === 'editCompliance')
            ? (_openBlock(), _createBlock(_component_editCompliance, {
                key: 'editCompliance-' + _ctx.detailsParams.complianceId,
                complianceId: _ctx.detailsParams.complianceId,
                modalMode: true,
                onHeaderInfo: _ctx.setDetailsHeader,
                onOpenNested: _ctx.openNested
              }, null, 8, ["complianceId", "onHeaderInfo", "onOpenNested"]))
            : (_ctx.detailsView === 'complianceControls')
              ? (_openBlock(), _createBlock(_component_complianceControls, {
                  key: 'complianceControls-' + _ctx.detailsParams.complianceId,
                  complianceId: _ctx.detailsParams.complianceId,
                  modalMode: true,
                  onHeaderInfo: _ctx.setDetailsHeader,
                  onOpenNested: _ctx.openNested
                }, null, 8, ["complianceId", "onHeaderInfo", "onOpenNested"]))
              : (_ctx.detailsView === 'startCompliance')
                ? (_openBlock(), _createBlock(_component_startCompliance, {
                    key: 'startCompliance-' + _ctx.detailsParams.complianceId,
                    complianceId: _ctx.detailsParams.complianceId,
                    modalMode: true,
                    onHeaderInfo: _ctx.setDetailsHeader,
                    onOpenNested: _ctx.openNested
                  }, null, 8, ["complianceId", "onHeaderInfo", "onOpenNested"]))
                : (_ctx.detailsView === 'complianceTask')
                  ? (_openBlock(), _createBlock(_component_taskEdit, {
                      key: 'complianceTask-' + _ctx.detailsParams.taskId,
                      complianceId: _ctx.detailsParams.complianceId,
                      taskId: _ctx.detailsParams.taskId,
                      modalMode: true,
                      onHeaderInfo: _ctx.setDetailsHeader,
                      onOpenNested: _ctx.openNested
                    }, null, 8, ["complianceId", "taskId", "onHeaderInfo", "onOpenNested"]))
                  : (_ctx.detailsView === 'crTask')
                    ? (_openBlock(), _createBlock(_component_crTaskEdit, {
                        key: 'crTask-' + _ctx.detailsParams.taskId,
                        taskId: _ctx.detailsParams.taskId,
                        complianceId: _ctx.detailsParams.complianceId,
                        modalMode: true,
                        onHeaderInfo: _ctx.setDetailsHeader,
                        onOpenNested: _ctx.openNested
                      }, null, 8, ["taskId", "complianceId", "onHeaderInfo", "onOpenNested"]))
                    : (_ctx.detailsView === 'findings')
                      ? (_openBlock(), _createBlock(_component_findings, {
                          key: 'findings-' + _ctx.detailsParams.findingId,
                          findingId: _ctx.detailsParams.findingId,
                          modalMode: true,
                          onHeaderInfo: _ctx.setDetailsHeader,
                          onOpenNested: _ctx.openNested
                        }, null, 8, ["findingId", "onHeaderInfo", "onOpenNested"]))
                      : (_ctx.detailsView === 'actionTask')
                        ? (_openBlock(), _createBlock(_component_actionTaskEdit, {
                            key: 'actionTask-' + _ctx.detailsParams.taskId,
                            findingId: _ctx.detailsParams.findingId,
                            taskId: _ctx.detailsParams.taskId,
                            modalMode: true,
                            onHeaderInfo: _ctx.setDetailsHeader,
                            onOpenNested: _ctx.openNested
                          }, null, 8, ["findingId", "taskId", "onHeaderInfo", "onOpenNested"]))
                        : (_ctx.detailsView === 'departmentControls')
                          ? (_openBlock(), _createBlock(_component_editControl, {
                              key: 'departmentControls-' + _ctx.detailsParams.id,
                              id: _ctx.detailsParams.id,
                              modalMode: true,
                              onHeaderInfo: _ctx.setDetailsHeader,
                              onOpenNested: _ctx.openNested
                            }, null, 8, ["id", "onHeaderInfo", "onOpenNested"]))
                          : (_ctx.detailsView === 'systemControlMapping')
                            ? (_openBlock(), _createBlock(_component_systemControlMapping, {
                                key: 'systemControlMapping-' + _ctx.detailsParams.systemId,
                                systemId: _ctx.detailsParams.systemId,
                                modalMode: true,
                                onHeaderInfo: _ctx.setDetailsHeader,
                                onOpenNested: _ctx.openNested
                              }, null, 8, ["systemId", "onHeaderInfo", "onOpenNested"]))
                            : (_ctx.detailsView === 'projectControls')
                              ? (_openBlock(), _createBlock(_component_projectControlMapping, {
                                  key: 'projectControls-' + _ctx.detailsParams.id,
                                  id: _ctx.detailsParams.id,
                                  modalMode: true,
                                  onHeaderInfo: _ctx.setDetailsHeader,
                                  onOpenNested: _ctx.openNested
                                }, null, 8, ["id", "onHeaderInfo", "onOpenNested"]))
                              : (_ctx.detailsView === 'manageRootControlMap')
                                ? (_openBlock(), _createBlock(_component_manageRootControlMap, {
                                    key: 'manageRootControlMap-' + _ctx.detailsParams.controlId,
                                    controlId: _ctx.detailsParams.controlId,
                                    from: _ctx.detailsParams.from,
                                    modalMode: true,
                                    onHeaderInfo: _ctx.setDetailsHeader,
                                    onOpenNested: _ctx.openNested
                                  }, null, 8, ["controlId", "from", "onHeaderInfo", "onOpenNested"]))
                                : (_ctx.detailsView === 'objectiveControls')
                                  ? (_openBlock(), _createBlock(_component_objectiveControlsMap, {
                                      key: 'objectiveControls-' + _ctx.detailsParams.objectiveId,
                                      objectiveId: _ctx.detailsParams.objectiveId,
                                      modalMode: true,
                                      onHeaderInfo: _ctx.setDetailsHeader,
                                      onOpenNested: _ctx.openNested
                                    }, null, 8, ["objectiveId", "onHeaderInfo", "onOpenNested"]))
                                  : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "showBack", "onClose", "onBack"]))
}